/* ==================================================
  ブログ記事
  目次の自動生成・リンクのコピー・読み進めた割合の帯・X の埋め込み
===================================================*/

/* ------------------------------
  目次: 本文の h2 と h3 から作る
------------------------------*/

const buildToc = () => {
  const tocs = document.querySelectorAll('[data-article-toc]');
  const content = document.querySelector('[data-article-content]');
  if (!tocs.length || !content) return;

  const headings = [...content.querySelectorAll('h2, h3')].filter((heading) =>
    heading.textContent.trim()
  );
  if (headings.length < 2) return;
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `section-${index + 1}`;
  });

  /* 目次は本文の上と左の列の2か所に置けるので、それぞれに同じ一覧を作る */
  tocs.forEach((toc) => {
    const list = toc.querySelector('ol');
    let current = null;
    let h2Number = 0;

    headings.forEach((heading) => {
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();

      if (heading.tagName === 'H2' || !current) {
        h2Number += 1;
        const item = document.createElement('li');
        item.className = 'c_article-toc__item';
        const number = document.createElement('span');
        number.className = 'c_article-toc__number';
        number.textContent = `${String(h2Number).padStart(2, '0')}.`;
        link.prepend(number);
        item.append(link);
        list.append(item);
        current = item;
      } else {
        let sub = current.querySelector('ul');
        if (!sub) {
          sub = document.createElement('ul');
          sub.className = 'c_article-toc__sub';
          current.append(sub);
        }
        const item = document.createElement('li');
        item.append(link);
        sub.append(item);
      }
    });

    toc.hidden = false;
  });

  /* 左の列の目次は、読んでいる見出しに印を付ける */
  const aside = document.querySelector('.c_article-toc--aside');
  if (!aside) return;
  const links = new Map(
    headings.map((heading) => [heading.id, aside.querySelector(`a[href="#${heading.id}"]`)])
  );
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        links.forEach((link) => link?.classList.remove('is-current'));
        const current = links.get(entry.target.id);
        if (!current) return;
        current.classList.add('is-current');
        /* 目次の中がスクロールするときは、読んでいる見出しを目次の中ほどに出す */
        if (aside.scrollHeight > aside.clientHeight) {
          aside.scrollTo({ top: current.offsetTop - aside.clientHeight / 2, behavior: 'smooth' });
        }
      });
    },
    { rootMargin: '0px 0px -70% 0px' }
  );
  headings.forEach((heading) => observer.observe(heading));
};

/* ------------------------------
  リンクのコピー
------------------------------*/

const bindCopyLink = () => {
  const button = document.querySelector('[data-copy-link]');
  const status = document.querySelector('[data-copy-status]');
  if (!button || !navigator.clipboard) return;

  button.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(button.dataset.copyLink);
      status.textContent = button.dataset.copiedLabel;
      setTimeout(() => {
        status.textContent = '';
      }, 2500);
    } catch (error) {
      console.error(error);
    }
  });
};

/* ------------------------------
  読み進めた割合の帯: 本文に入ったら出し、読み終えたら隠す
------------------------------*/

const bindProgress = () => {
  const reading = document.querySelector('[data-article-reading]');
  const bar = document.querySelector('[data-article-progress]');
  const content = document.querySelector('[data-article-content]');
  if (!reading || !bar || !content) return;

  let ticking = false;
  const update = () => {
    const rect = content.getBoundingClientRect();
    const total = rect.height - window.innerHeight;
    const ratio = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 1;
    bar.style.transform = `scaleX(${ratio})`;
    reading.classList.toggle('is-visible', rect.top < 160 && rect.bottom > 160);
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );
  update();
};

/* ------------------------------
  X の埋め込み
  本文に貼った <script> は Shopify に無効化されるため、埋め込みがある記事だけここで読み込む
------------------------------*/

const loadTweets = () => {
  const tweets = [...document.querySelectorAll('[data-article-content] blockquote.twitter-tweet')];
  /* 中身の無い埋め込みは読み込み失敗の枠だけ残るので消す */
  tweets.filter((tweet) => !tweet.textContent.trim()).forEach((tweet) => tweet.remove());
  if (!tweets.some((tweet) => tweet.isConnected)) return;

  const script = document.createElement('script');
  script.src = 'https://platform.twitter.com/widgets.js';
  script.async = true;
  script.charset = 'utf-8';
  document.body.append(script);
};

/* ------------------------------
  サイドバーの追従: 画面より高いときは下端を画面の下にそろえる
------------------------------*/

const fitSticky = (element, top) => {
  if (!element) return;
  const update = () => {
    const overflow = element.offsetHeight + top + 24 - window.innerHeight;
    element.style.setProperty('--c_sticky-top', `${overflow > 0 ? top - overflow : top}px`);
  };
  new ResizeObserver(update).observe(element);
  window.addEventListener('resize', update);
};

buildToc();
loadTweets();
/*  左の列に目次があるときは、目次だけが追従する（c_article.css）。無いときは列ごと追従させる  */
if (!document.querySelector('.c_article-toc--aside'))
  fitSticky(document.querySelector('.c_article__aside'), 160);
bindCopyLink();
bindProgress();
